/**
 * @generated SignedSource<<9831f8d0283d24b5c5b432dec6cf0caa>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type PopupImportJobStatus = "QUEUED" | "RUNNING" | "COMPLETED" | "COMPLETED_WITH_ERRORS" | "FAILED" | "%future added value";
export type AcknowledgePopupImportJobInput = {
  clientMutationId?: string | null;
  slug: string;
};
export type PopupListPageAcknowledgeMutation$variables = {
  input: AcknowledgePopupImportJobInput;
};
export type PopupListPageAcknowledgeMutationVariables = PopupListPageAcknowledgeMutation$variables;
export type PopupListPageAcknowledgeMutation$data = {
  readonly acknowledgePopupImportJob: {
    readonly popupImportJob: {
      readonly slug: string;
      readonly status: PopupImportJobStatus;
    };
  } | null;
};
export type PopupListPageAcknowledgeMutationResponse = PopupListPageAcknowledgeMutation$data;
export type PopupListPageAcknowledgeMutation = {
  variables: PopupListPageAcknowledgeMutationVariables;
  response: PopupListPageAcknowledgeMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PopupListPageAcknowledgeMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "AcknowledgePopupImportJobPayload",
        "kind": "LinkedField",
        "name": "acknowledgePopupImportJob",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PopupImportJob",
            "kind": "LinkedField",
            "name": "popupImportJob",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PopupListPageAcknowledgeMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "AcknowledgePopupImportJobPayload",
        "kind": "LinkedField",
        "name": "acknowledgePopupImportJob",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PopupImportJob",
            "kind": "LinkedField",
            "name": "popupImportJob",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "4d68faeb53446fcb217b8092f68fe9fb",
    "id": null,
    "metadata": {},
    "name": "PopupListPageAcknowledgeMutation",
    "operationKind": "mutation",
    "text": "mutation PopupListPageAcknowledgeMutation(\n  $input: AcknowledgePopupImportJobInput!\n) {\n  acknowledgePopupImportJob(input: $input) {\n    popupImportJob {\n      slug\n      status\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "6106ffc97d8a90a3457e9e35bfd7a996";

export default node;
